import { render, staticRenderFns } from "./SectionOS.vue?vue&type=template&id=4da4a537&scoped=true&"
import script from "./SectionOS.vue?vue&type=script&lang=js&"
export * from "./SectionOS.vue?vue&type=script&lang=js&"
import style0 from "./SectionOS.vue?vue&type=style&index=0&id=4da4a537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da4a537",
  null
  
)

export default component.exports